import * as React from 'react';
import {isNullOrUndefined} from "util";

const classNames = require('classnames');

interface Props {
	/**
	 * Css custom class name.
	 */
	customClass?: string;
}

export default class Row extends React.Component<Props, {}> {
	render() {
		const classes = classNames({
			"row": true,
			[`${this.props.customClass}`]: !isNullOrUndefined(this.props.customClass)
		});
		return (
			<div className={classes}>
				{this.props.children}
			</div>
		);
	}
}